var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"main"}},[(_vm.type == 'booking' || _vm.type == 'checkout' || _vm.type == 'fail' || _vm.type == 'paid')?_c('BookingMain'):_vm._e(),(_vm.type == 'delete')?_c('DeleteReservation'):_vm._e(),(_vm.type == 'quotas')?_c('QuotaLoad'):_vm._e(),(_vm.type == 'requestQuota')?_c('RequestQuota'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }